module.exports = ".contract-table tr td {\r\n    padding-right: 5px!important;\r\n}\r\n\r\n.contract-table tr td * {\r\n    width: 100%!important;\r\n}"